import { useDispatch, useSelector } from 'react-redux';
import { getTickets, openTicketModal } from '../../../store/fuse/nivelService';
import { WrapperTotalTicketByStatus } from './styles';

const { VictoryChart, VictoryTheme, VictoryGroup, VictoryAxis, VictoryBar, VictoryStack, VictoryLabel } = require('victory');

const TotalByStatus = ({ bystatus }) => {
  const dispatch = useDispatch();
  const open = useSelector((state) => state?.fuse?.nivelService?.ticketModal?.open);
  const chartData = bystatus.filter((statusData) => statusData.nameTicket !== 'Total General');

  const darkMode = useSelector((state) => state?.fuse?.dashboard?.darkMode);


  const initialData = [
    { nameTicket: 'Cargando', colorTicket: '#999', totalTicket: 0 },
    { nameTicket: 'Cargando', colorTicket: '#999', totalTicket: 0 },
    { nameTicket: 'Cargando', colorTicket: '#999', totalTicket: 0 },
  ];

  const handleOpenModal = (data) => {
    if (data.nameTicket === 'Abiertos') {
      dispatch(getTickets(0, 0, 2));
    }
    if (data.nameTicket === 'En Curso') {
      dispatch(getTickets(0, 0, 3));
    }
    if (data.nameTicket === 'Resueltos') {
      dispatch(getTickets(0, 0, 1));
    }
    dispatch(openTicketModal(open));
  };

  const loadData = () => {
    if (!chartData) {
      return initialData;
    }
    if (chartData.length === 1) {
      return initialData;
    }
    return chartData;
  }

  return (
    <WrapperTotalTicketByStatus>
      <div className="section-by-status">
        <div className="w-full">
          <h3>Total Tickets por Status</h3>
          <div className="section-chart">
            <VictoryChart
              theme={VictoryTheme.material}
              width={950}
              height={450}
              padding={{ top: 50, bottom: 100, right: 50, left: 100 }}
              domainPadding={40}
            >
              <VictoryAxis
                style={{
                  ticks: { stroke: 'none' }, // Hide the ticks
                  grid: { stroke: 'none' },
                  tickLabels: {
                    fill: darkMode ? '#FFFFFF' : '#000000', // Color de las etiquetas del eje X
                    fontSize: 12, // Tamaño de las etiquetas del eje X
                    fontWeight: 'bold' // Negrita opcional
                  },
                  axis: { stroke: darkMode ? '#FFFFFF' : '#000000' }, // Color de la línea del eje X
                }}
              />
              <VictoryAxis
                dependentAxis
                style={{
                  tickLabels: {
                    fill: darkMode ? '#FFFFFF' : '#000000', // Color de las etiquetas del eje Y
                    fontSize: 12, // Tamaño de las etiquetas del eje Y
                    fontWeight: 'bold' // Negrita opcional
                  },
                  axis: { stroke: darkMode ? '#FFFFFF' : '#000000' }, // Color de la línea del eje Y
                }}
              />
              <VictoryGroup
                horizontal
                offset={10}
                style={{
                  data: {
                    width: 20,
                    fill: darkMode ? '#FFFFFF' : '#000000'
                  },
                }}
              >
                <VictoryStack colorScale={['tomato', 'orange', 'gold']}>
                  <VictoryBar
                    data={loadData()}
                    style={{
                      data: {
                        fill: ({ datum }) => datum.colorTicket,
                        cursor: 'pointer',
                      },
                    }}
                    labels={({ datum }) => `${datum.nameTicket}`}
                    x="nameTicket"
                    y="totalTicket"
                    labelComponent={<VictoryLabel 
                      style={{ fill: darkMode ? '#FFFFFF' : '#000000' }}  text={({ datum }) => datum.totalTicket}
                    />}
                    events={[
                      {
                        target: 'data',
                        eventHandlers: {
                          onClick: (evt, data) => {
                            handleOpenModal(data.datum);
                          },
                        },
                      },
                    ]}
                  />
                </VictoryStack>
              </VictoryGroup>
            </VictoryChart>
          </div>
        </div>
        <div className="section-filter">
          {chartData?.map((data, index) => (
            <div className="section-estatus" key={index}>
              <div className="section-square" style={{ backgroundColor: data.colorTicket }} />
              <p>{data.nameTicket}</p>
            </div>
          ))}
        </div>
      </div>
    </WrapperTotalTicketByStatus>
  );
};

export default TotalByStatus;
